/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const updateEmailRequestSchema = z
	.object({
		email: z.email().min(1),
		otp_code: z.string().min(1),
	})
	.describe("Сериализатор обновления email.");
